import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Injector, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { CalendarDateFormatter, CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView, DateAdapter } from 'angular-calendar';
import { MonthViewDay } from 'calendar-utils';
import { startOfDay, isSameDay } from 'date-fns';
import { Subject } from 'rxjs';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { LaasSettingService } from 'src/app/core/services/laas-setting.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { WarehouseCalendarService } from '../../service/warehouse-calendar.service';
import { CustomDateFormatter } from '../warehouse-calendar/custom-date-formatter.provider';

const pinkCell: 'pink-cell' = 'pink-cell';

export interface CustomCalendarEvent extends CalendarEvent {

  descr?: any;
  memo?: any;
  workFlag?: any;
  createUser?: any;
  updateUser?: any;

}

export interface CustomMonthViewDay extends MonthViewDay {
  customEvents?: CustomCalendarEvent[];
}

@Component({
  selector: 'laas-laas-calender',
  templateUrl: './laas-calender.component.html',
  styleUrls: ['./laas-calender.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ]
})
export class LaasCalenderComponent extends SessionBaseComponent implements OnInit {
  readonly permissionCode = PermissionConstants.ViewLaaSCalender;
  currentLang: string = this.laasSetting.language;
  @Output() ItemLicenseImported: EventEmitter<any>;

  @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any> | undefined;

  @Output() currentMonth!: string;

  @Output() currentYear!: string;

  isEditWarehouseCalender: Boolean = false;

  laasSetting: LaasSettingService;

  language: string;

  isEditShow: boolean;

  view: CalendarView = CalendarView.Month;

  calendarView = CalendarView;

  viewDate: Date = new Date();

  monthList!: any[];

  yearList!: any[];

  clickDate: any;

  // locale: string = this.laasSetting.language;
  locale: string = 'en'

  modalData: {
    action: string;
    event: CalendarEvent;
  } | undefined;

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.isEditShow = !this.isEditShow;
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  refresh: Subject<any> = new Subject();

  events: CustomCalendarEvent[] = [];

  activeDayIsOpen: boolean = false;

  showEditModal: boolean = false;

  showCreateModal: boolean = false;

  showCopyModal: boolean = false;

  currentCalendarEvent: CustomCalendarEvent[] = [];

  yearLabel!: string;

  monthLabel!: string;
  constructor(
    injector: Injector,
    private warehouseCalendarService: WarehouseCalendarService,
    private changeDetector: ChangeDetectorRef,
    private datePipe: DatePipe) {
      super(injector);

      this.ItemLicenseImported = new EventEmitter<any>();

      this.viewDateChange = new EventEmitter<Date>();

      this.isEditShow = false;

      this.laasSetting = injector.get(LaasSettingService);

      this.language = this.laasSetting.language;

      this.queryAllByFacilityAndCategory("");
    }

    async ngOnInit(): Promise<void> {
      await super.ngOnInit();

      this.isEditWarehouseCalender = this.permissionCodes.includes(PermissionConstants.EditLaaSCalender);
       //rbac to maintain this page
      var canInPage = this.permissionCodes.includes(this.permissionCode);
      console.log(canInPage)
      if (!canInPage) {
        //go unAuthorize
        this.routeStateService.navigateTo('/Error/unAuthorize');
      }

      this.translateService.get('WarehouseCalendar.Calendar.Year')
      .subscribe({
        next: result => {

          this.yearLabel = result;

          var thisYear = new Date().getFullYear();
          this.yearList =  [];
          for(var i = thisYear - 10; thisYear + 10 >= i; i++) {
            let yearObject : any = {};
            yearObject.label = i.toString() + this.yearLabel;
            yearObject.value = i.toString();
            this.yearList.push(yearObject);
          }

          this.currentYear = new Date().getFullYear().toString();
          this.changeDetector.detectChanges();
        }
      });

      this.translateService.get('WarehouseCalendar.Calendar.Month')
      .subscribe({
        next: result => {
          this.monthLabel = result;

          this.monthList = [
            { label: '1' + this.monthLabel, value: '1' },
            { label: '2' + this.monthLabel, value: '2' },
            { label: '3' + this.monthLabel, value: '3' },
            { label: '4' + this.monthLabel, value: '4' },
            { label: '5' + this.monthLabel, value: '5' },
            { label: '6' + this.monthLabel, value: '6' },
            { label: '7' + this.monthLabel, value: '7' },
            { label: '8' + this.monthLabel, value: '8' },
            { label: '9' + this.monthLabel, value: '9' },
            { label: '10' + this.monthLabel, value: '10' },
            { label: '11' + this.monthLabel, value: '11' },
            { label: '12' + this.monthLabel, value: '12' }
          ];

          var thisMonth = new Date().getMonth() + 1;
          this.currentMonth = thisMonth.toString();
          this.changeDetector.detectChanges();

        }
      });

    }

    isWorkDay (workDay: string) {

      if (workDay == '0') {
        return true;
      } else {
        return false;
      }

    }

    dayClicked({ date, events }: { date: Date; events: CustomCalendarEvent[] }): void {

      if (this.isEditWarehouseCalender) {

        this.viewDate = date;

        if ((isSameDay(this.viewDate, date))) {
          this.showEditModal = true;
          this.currentCalendarEvent = events;
          this.clickDate = this.datePipe.transform(date, 'yyyy/MM/dd');
        }

      } else {
        this.viewDate = date;

        if ((isSameDay(this.viewDate, date))) {
          if (events.length > 0) {
            events[0].cssClass = pinkCell;
            setTimeout(() => {
              this.viewDate = new Date(this.currentYear + "-" + this.currentMonth);
              this.refresh.next(null);
            },500);
          }

        }

      }

    }

    eventTimesChanged({
      event,
      newStart,
      newEnd,
    }: CalendarEventTimesChangedEvent): void {
      this.events = this.events.map((iEvent) => {
        if (iEvent === event) {
          return {
            ...event,
            start: newStart,
            end: newEnd
          };
        }
        return iEvent;
      });
      this.handleEvent('Dropped or resized', event);
    }

    handleEvent(action: string, event: CalendarEvent): void {
      this.modalData = { event, action };
    }

    deleteEvent(eventToDelete: CalendarEvent): void {
      this.events = this.events.filter((event) => event !== eventToDelete);
    }

    getCurrentDate(): void {

      var thisMonth = new Date().getMonth() + 1;
      this.currentMonth = thisMonth.toString();
      this.currentYear = new Date().getFullYear().toString();

    }

    setView(view: CalendarView): void {
      this.view = view;
    }

    subOneMonth(event: any): void {
      var tempMonth = Number(this.currentMonth) - 1;
      var tempYear = Number(this.currentYear);
      if (tempMonth == 0) {

        if (this.currentYear > this.yearList[0].value) {

          // 非第一年的第一天
          tempMonth = 12;
          tempYear = tempYear - 1;
          this.currentYear = tempYear.toString();

        } else {
          tempMonth = 1;
        }
      }

      this.currentMonth = tempMonth.toString();
      this.dateOnChange(event);
    }

    goToToday(event: any): void {
      this.getCurrentDate();
      this.dateOnChange(event);
    }

    addOneMonth(event: any): void {
      var tempMonth = Number(this.currentMonth) + 1;
      var tempYear = Number(this.currentYear);

      if (tempMonth == 13) {

        if (this.currentYear < this.yearList[20].value) {

          // 非最後一年的最後一天
          tempMonth = 1;
          tempYear = tempYear + 1;
          this.currentYear = tempYear.toString();

        } else {
          tempMonth = 12;
        }
      }

      this.currentMonth = tempMonth.toString();
      this.dateOnChange(event);
    }

    dateOnChange(event: any): void {
      this.viewDate = new Date(this.currentYear + "-" + this.currentMonth);
      this.activeDayIsOpen = false;
    }

    beforeMonthViewRender({ body }: { body: MonthViewDay[] }): void {

       body.forEach((day) => {
        day.events.forEach((event) => {
          // allDay代表假日
          if (event.allDay) {
            day.cssClass = pinkCell;
          }
        });
      });

    }

    queryAllByFacilityAndCategory(viewDate: any): void {
      this.warehouseCalendarService.queryAllByFacilityAndCategory(this.laasSetting.facility, "LAAS").subscribe({
        next: result => {
          this.events = [...result].map((facilityCalendarBean: any) => {
            return {
              start: startOfDay(new Date(facilityCalendarBean.workDate)),
              title: '',
              allDay: this.isWorkDay(facilityCalendarBean.workFlag),
              descr: facilityCalendarBean.descr,
              memo: facilityCalendarBean.memo,
              workFlag: facilityCalendarBean.workFlag,
              createUser: facilityCalendarBean.createUser,
              updateUser: facilityCalendarBean.updateUser
            }
          });

          if (viewDate == "") {
            this.viewDate = new Date();
            this.refresh.next(null);
          } else {
            this.viewDate = new Date(viewDate);
            this.refresh.next(null);
          }

        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 400) {
            this.toastService.error(error.error);
          }
        }
      });
    }

    warehouseCalendarImported(event: any): void {

      this.showEditModal = false;
      // 這邊要把月份重新整理
      this.dateOnChange(event);
      this.queryAllByFacilityAndCategory(this.viewDate);

    }

    CreateCalendar(event: any): void {
       this.showCreateModal = true;
    }

    CopyCalendar(event: any): void {
      this.showCopyModal = true;
    }

}
